import React from "react";

const STEPS = [
  {
    nr: "01",
    title: "Erstgespräch",
    desc: "Unverbindliches Kennenlernen vor Ort oder digital. Wir hören zu, prüfen Machbarkeit und stecken den Rahmen ab.",
  },
  {
    nr: "02",
    title: "Planung & Angebot",
    desc: "Detaillierte Leistungsbeschreibung mit transparenter Kalkulation. Festpreis statt Überraschungen.",
  },
  {
    nr: "03",
    title: "Realisierung",
    desc: "Ein fester Bauleiter koordiniert Gewerke und Termine. Wöchentliche Updates, klare Kommunikation.",
  },
  {
    nr: "04",
    title: "Übergabe & Service",
    desc: "Mangelfreie Abnahme, ausführliche Dokumentation und persönliche Erreichbarkeit auch nach Projektende.",
  },
];

export default function Prozess() {
  return (
    <section
      id="prozess"
      data-testid="prozess-section"
      className="bg-zinc-50 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-red-600" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-red-600">
              So arbeiten wir
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter text-zinc-900 leading-[0.95]">
            Vier Schritte zum<br />
            <span className="text-red-600">fertigen Bau.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-zinc-200">
          {STEPS.map((s, i) => (
            <div
              key={i}
              data-testid={`prozess-step-${i}`}
              className="border-r border-b border-zinc-200 bg-white p-8 md:p-10 hover:bg-zinc-950 hover:text-white transition-colors duration-500 group"
            >
              <div className="font-display text-6xl font-black text-red-600 leading-none">
                {s.nr}
              </div>
              <div className="mt-8 h-px w-12 bg-zinc-300 group-hover:bg-red-500 transition-colors" />
              <h3 className="font-display mt-6 text-2xl font-bold uppercase tracking-tight">
                {s.title}
              </h3>
              <p className="mt-4 text-sm text-zinc-600 group-hover:text-zinc-300 transition-colors font-light leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
